import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Toast } from '../../services/models/toast.model';
import { CreateToast, RemoveToast } from './toast.actions';
import { ToastState } from './toast.state';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastFacade {
  private readonly store = inject(Store);

  @Select(ToastState.toasts) toasts$: Observable<Toast[]>;

  createToast(toast: Partial<Toast>) {
    this.store.dispatch(new CreateToast(toast));
  }

  showInfo(message: string) {
    this.createToast({ message, type: 'info' });
  }

  showError(message: string) {
    this.createToast({ message, type: 'error' });
  }

  showSuccess(message: string) {
    this.createToast({ message, type: 'success' });
  }

  showWarning(message: string) {
    this.createToast({ message, type: 'warning' });
  }

  removeToast(id: string) {
    this.store.dispatch(new RemoveToast(id));
  }
}
